



















































































import Vue from "vue";
import { mapState } from "vuex";
import Footer from "../components/master/Footer.vue";
import PasswordInput from "../components/common/passwordInput.vue";
import AbpBase from "../lib/abpbase";

export default AbpBase.extend({
  components: {
    Footer,
    PasswordInput,
  },
  beforeRouteEnter(to, from, next) {
    if (Object.keys(to.query).length !== 0) {
      next((vm) => {
        (vm as any).getParameters(to.query.id, to.query.resetcode);
      });
    }
  },
  data() {
    return {
      resetPasswordModel: {
        id: 0,
        resetCode: "",
        emailAddress: "",
        newPassword: "",
        newPasswordConfirm: "",
      },
      has_eight_characters: false,
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      has_special: false,
      resetCompleted: false,
      emailAddress: "",
      rules: {
        newPassword: [
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("Please enter your new password"));
              } else {
                if ((this as any).checkPassword(value)) {
                  if ((this as any).resetPasswordModel.newPasswordConfirm !== "") {
                    (this.$refs.resetform as any).validateField("newPasswordConfirm");
                  }
                } else {
                  callback(new Error("Not a valid password."));
                }

                callback();
              }
            },
            trigger: "blur",
          },
        ],
        newPasswordConfirm: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value !== (this as any).resetPasswordModel.newPassword) {
                callback(new Error("Passwords do not match!"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("session", ["user"]),
  },
  watch: {},
  methods: {
    checkPassword(input) {
      let password = input || this.resetPasswordModel.newPassword;
      this.has_eight_characters = password && password.length > 7;
      this.has_number = /\d/.test(password);
      this.has_lowercase = /[a-z]/.test(password);
      this.has_uppercase = /[A-Z]/.test(password);
      this.has_special = /[!@#\$%\^\&*\)\(+=._-]/.test(password);

      return this.has_eight_characters && this.has_number && this.has_lowercase && this.has_uppercase && this.has_special;
    },
    getParameters(id, resetCode) {
      this.resetPasswordModel.id = id;
      this.resetPasswordModel.resetCode = resetCode;
    },
    async resetPassword() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      let context = this;
      (this.$refs.resetform as any).validate(async (valid: boolean) => {
        if (valid) {
          this.$Message.loading({
            content: "Reset password...",
            duration: 0,
          });
          let requestData = {
            id: this.resetPasswordModel.id,
            resetCode: this.resetPasswordModel.resetCode,
            newPassword: this.resetPasswordModel.newPassword,
          };

          context.$store.dispatch("account/resetPassword", requestData).then((response) => {
            setTimeout(() => {
              context.$Message.destroy();
            }, 500);
            target.disabled = false;
            this.resetCompleted = true;
            this.emailAddress = response.emailAddress;
          });
        } else {
          target.disabled = false;
        }
      });
    },
  },
});
